import { createRouter, RouteRecordRaw, createWebHistory } from "vue-router";
import promotionCourseRouter from "./promotion-course/index";
import studentInformation from "./student-information/index";
import publicexamRouter from "./publicexam-router/index";
import quickReply from "./quick-reply/index";
import weChatAssistant from "./weChat-assistant/index";
import weChatSource from "./weChat-source/index";
import chooseSchool from "./choose-school/index";
import clueEntry from "./clue-entry/index";
import coursePriceBox from "./course-price-box/index"
import exclusivePractice from "./exclusive-practice/index"
import searchQuestionsByImage from "./search-questions-by-image/index"
import manualAuthorization from "./manual-authorization/index"
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home/index.vue"),
    children: [
      promotionCourseRouter,
      studentInformation,
      ...publicexamRouter,
      ...quickReply,
      ...chooseSchool,
      ...weChatSource,
      ...weChatAssistant,
      ...clueEntry,
      ...coursePriceBox,
      ...exclusivePractice,
      ...searchQuestionsByImage,
      ...manualAuthorization
    ]
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
